import { render, staticRenderFns } from "./EventBlock.vue?vue&type=template&id=15fdc6d0&scoped=true&"
import script from "./EventBlock.vue?vue&type=script&lang=ts&"
export * from "./EventBlock.vue?vue&type=script&lang=ts&"
import style0 from "./EventBlock.vue?vue&type=style&index=0&id=15fdc6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fdc6d0",
  null
  
)

export default component.exports